export enum ShareModalTabStatus {
    SHARE_WITH_PUBLIC,
    SHARE_WITH_CONTACTS
}
